import * as React from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
  Typography,
} from "@mui/material";
import ConfirmMusicNft from "../ConfirmMusicNft";
import notifier from "../Notifier";
import { useHistory } from "react-router-dom";
import {
  getHbar,
  getToken,
  getUsdt,
  getWalletId,
  serialize,
} from "../../constants/function";
import { useTranslation } from "react-i18next";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmNftPopup({ open, handleClose }) {
  const { t } = useTranslation("common");
  const [openPopup, setOpen] = React.useState(open);
  const history = useHistory();
  const checkBalance = () => {
    const balance = localStorage.getItem("balance");
    if (balance >= 200) {
      setOpen(true);
    } else {
      notifier.info(t("nftPopup.text2"));
      history.push(
        `/add-siki-token?${serialize({
          token: getToken(),
          hbar: getHbar(),
          walletId: getWalletId(),
          usdc: getUsdt(),
        })}`
      );
    }
  };
  React.useEffect(() => {
    return () => setOpen(false);
  }, []);

  return (
    <Box color="default">
      {/* <Dialog
        open={open}
        onBackdropClick={() => handleClose(false)}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#ffffff",
            borderRadius: 16,
            padding: 16,
          },
        }}
      >
        <DialogContent>
          <DialogContentText
            color="default"
            align="center"
            id="alert-dialog-slide-description"
          >
            {t("nftPopup.text1")}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            style={{ width: "50%", padding: "10px 45px !important" }}
            sx={{ backgroundColor: "#1E1E1E" }}
            onClick={() => handleClose(null)}
            color="default"
          >
            {t("no")}
          </Button>
          <Button
            style={{ width: "50%", padding: "10px 45px !important" }}
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
          >
            {t("yes")}
          </Button>
        </DialogActions>
      </Dialog> */}
      {openPopup ? (
        <ConfirmMusicNft
          open={openPopup}
          handleClose={(e, currency, units, platform) =>
            !e
              ? (setOpen(false), handleClose(e))
              : handleClose(e, currency, units, platform)
          }
        />
      ) : null}
    </Box>
  );
}
